import React, { useState } from "react";
import PageHeader from "src/components/shared/PageHeader";
import useAuthGlobal from "src/context/useAuthGlobal";

export default function ProfitPage() {
  const { userMe } = useAuthGlobal();
  const [sumWhouseId, setSumWHouseId] = useState();
  return (
    <React.Fragment>
      <PageHeader
        name="Quản lý Công nợ"
        subName="Báo cáo doanh thu"
        value={sumWhouseId}
        setValue={setSumWHouseId}
        item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
        userMe={userMe}
      />
    </React.Fragment>
  );
}
